import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';
import { SpacingBox, ClickableBox } from '../Boxes';
import { WhiteCheckIcon } from '../Icons';
import { If } from '../Conditional';
import { ProductCard } from './ProductCard';
import { ProductPresenter } from '../../presenters';
import { SmallProductCardList } from './SmallProductCardList';

const SelectCircle = ({ selected, onSelect }) => (
  <ClickableBox
    onClick={onSelect}
    className={styles.clickableAreaForSelectCircle}>
    <div
      className={cn(
        styles.selectCircle,
        selected ? styles.selectedCircle : null,
      )}>
      <If condition={!!selected}>{() => <WhiteCheckIcon size="xs" />}</If>
    </div>
  </ClickableBox>
);
SmallProductCardList.defaultProps = {
  onClick: () => {},
};
export const MultipleSelectableSmallProductCardList = ({
  selectedProducts,
  products,
  colours,
  tischOffensiveId,
  onClick,
  onSelect,
}) => (
  <div className="row">
    {products.map((p) => {
      const product = ProductPresenter(p);
      const productColours = colours ? colours[product.number] : null;

      return (
        <div
          style={{ position: 'relative' }}
          key={product.number}
          className="col-md-2 col-sm-12">
          <SpacingBox marginBottom="lg">
            <SelectCircle
              onSelect={() => onSelect(product.number)}
              selected={selectedProducts.includes(product.number)}
            />
            <ProductCard
              onClick={onClick}
              tischOffensiveId={tischOffensiveId}
              product={product}
              colours={productColours}
              />
          </SpacingBox>
        </div>
      );
    })}
  </div>
);
MultipleSelectableSmallProductCardList.defaultProps = {
  selectedProducts: [],
};
